/* common emotion styles used inside the CML editor */
import { css } from '@emotion/react';

// styles taken directly from https://www.figma.com/file/199O68clHPnYpeqcARrd1F/CML-updates%3A-Google-Q2-2021
export const hoverMenu = () => css`
  background: white;
  border: 1px solid var(--cds-color-interactive-primary-hover);
  border-radius: var(--cds-border-radius-50);
`;
